// src/lib/adminApi.js
const API_BASE = process.env.REACT_APP_API_BASE_URL;

const ADMIN_JWT_KEY = "ADMIN_JWT";

export const getAdminToken = () => {
  try {
    return localStorage.getItem(ADMIN_JWT_KEY) || "";
  } catch {
    return "";
  }
};

export const setAdminToken = (token) => {
  try {
    localStorage.setItem(ADMIN_JWT_KEY, token);
  } catch {}
};

export const clearAdminToken = () => {
  try {
    localStorage.removeItem(ADMIN_JWT_KEY);
  } catch {}
};

const authHeaders = () => {
  const token = getAdminToken();
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
};

export async function adminLogin(username, password) {
  const res = await fetch(`${API_BASE}/admin/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ username, password }),
  });

  const data = await res.json();
  return { res, data };
}

export async function adminCreatePromo(payload) {
  const res = await fetch(`${API_BASE}/admin/promo/create`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify(payload),
  });

  const data = await res.json();
  return { res, data };
}

export async function adminCreateAuto(spec) {
  const res = await fetch(`${API_BASE}/admin/promo/create-auto`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify({ spec }),
  });

  const data = await res.json();
  return { res, data };
}

export async function adminListPromos() {
  const res = await fetch(`${API_BASE}/admin/promo/list`, {
    method: "GET",
    headers: authHeaders(),
  });

  const data = await res.json();
  return { res, data };
}

export async function adminDisable(code) {
  const res = await fetch(`${API_BASE}/admin/promo/disable`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify({ code }),
  });

  const data = await res.json();
  return { res, data };
}

export async function adminEnable(code) {
  const res = await fetch(`${API_BASE}/admin/promo/enable`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify({ code }),
  });

  const data = await res.json();
  return { res, data };
}
